<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <div class="topup-container">
          <!-- When nothing topup waiting payment -->
          <div class="row grid-floor">
            <div
              v-if="status===0"
              class="grid-floor-col col-md-12 col-lg-6 col-sm-12"
            >
              <div class="title-price">
                Choose TOP UP Amount</div>
              <div class="price-list">
                <div
                  v-for="option in amountOptions"
                  :key="option.id"
                >
                  <input
                    :id="option.id"
                    type="radio"
                    name="brandType"
                    class="hidebx"
                    value="32GB"
                  >
                  <label
                    :for="option.id"
                    class="lbl-radio"
                    @click="clickedPrice(option.amount)"
                  >
                    <div class="display-box">
                      <div class="price">{{ option.amount }}</div>
                    </div>
                  </label>
                </div>
              </div>
              <div
                class="title-input-price label-note"
                data-note="(minimum Top Up IDR. 500.000)"
              >
                Or type your TOP UP amount
              </div>
              <validation-observer
                ref="valid"
                tag="form"
              >
                <validation-provider
                  #default="{ errors }"
                  name="saldo"
                  rules="required|min500"
                >
                  <b-form-input
                    id="input-amount"
                    v-model="price"
                    class="input-amount mb-0"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Type topup amount"
                    @input="clickedPrice"
                  />
                  <small class="text-danger mb-1">{{ errors[0] }}</small>
                  <b-button
                    class="btn btn-success mt-1"
                    @click="validation"
                  >
                    Submit
                  </b-button>
                </validation-provider>
              </validation-observer>
            </div>
            <div
              v-if="status===1 || status===2"
              class="grid-floor-col col-md-12 col-lg-6 col-sm-12"
            >
              <div class="title-price">
                Please transfer to following Bank Information below:</div>
              <span class="content-bank-information">
                <p>Bank Name: {{ dataInfo.topup_payment_info.bank_name }}</p>
                <p>Account Name: {{ dataInfo.topup_payment_info.account_name }}</p>
                <p>Account Number: {{ dataInfo.topup_payment_info.account_number }}</p>
              </span>
              <hr>
              <b-row>
                <b-col md="6">
                  <span class="note-information-transfered">
                    Thank you, please upload your transfer proof by clicking the right button. We will validate your transaction details in a moments
                  </span>
                </b-col>
                <b-col md="6">
                  <b-button
                    v-if="status === 1"
                    class="btn btn-primary btn-upload-proof"
                    @click="showFormUploadTopup"
                  >
                    Upload Payment Proof</b-button>
                  <b-button
                    v-if="status === 1"
                    class="btn btn-default btn-cancel-order"
                    @click="cancelOrder"
                  >
                    Cancel Order</b-button>
                </b-col>
              </b-row>
            </div>
            <div class="grid-floor-col col-md-12 col-lg-6 col-sm-12">
              <div class="title-topup-history">
                TOP UP History
              </div>
              <!-- Hide table -->
              <b-row
                class="filter-tools"
                style="margin-bottom: 20px;margin-top: 10px;"
              >
                <b-col
                  md="3"
                >
                  <b-form-datepicker
                    id="startdate"
                    v-model="startdate"
                    class="input-date"
                    locale="ind"
                    reset-button
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    placeholder="Start Period"
                    @context="onContext"
                  />
                </b-col>
                <b-col
                  md="3"
                >
                  <b-form-datepicker
                    id="enddate"
                    v-model="enddate"
                    class="input-date"
                    locale="ind"
                    reset-button
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    placeholder="End Period"
                    @context="onContext"
                  />
                </b-col>
                <b-col md="2">
                  <b-button
                    class="btn btn-primary filter-btn"
                    :disabled="disabledBtnFilter"
                    @click="filterDate"
                  >
                    <feather-icon icon="FilterIcon" />
                    Filter
                  </b-button>
                </b-col>
                <b-col md="4">
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      v-model="search"
                      placeholder="Search"
                    />
                    <b-input-group-append is-text>
                      <feather-icon icon="SearchIcon" />
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
              </b-row>
              <div class="table-slip">
                <data-table
                  v-if="true"
                  :data-table="dataHistoryTopupItem"
                  :field-table="dataHistoryTopupField"
                  :status="dataHistoryTopupStatus"
                  :data-for="dataFor"
                  :table-for="tableFor"
                  :mutation-for="mutationFor"
                  :action="action"
                  :filter-search="filterSearch"
                >
                  <template
                    #cell(due_date)="data"
                  >
                    {{ formatDateIdr(data.value) }}
                  </template>
                  <template #cell(total)="data">
                    {{ formatPrice(data.value) }}
                  </template>
                  <template
                    #cell(actions)="data"
                  >
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      @click="viewDetail(data.item.invoice_no)"
                    >
                      <span class="align-middle">View</span>
                    </b-button>
                  </template>
                </data-table>
              </div>
              <!-- End hide table -->
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
    <!-- Modal information topup order -->
    <div>
      <b-modal
        id="modal-1"
        ref="success-topup"
        :hide-header-close="true"
        :ok-only="true"
        :ok-title="titleCloseBtn"
        :hide-header="true"
        :no-close-on-backdrop="true"
        size="lg"
        centered
        @ok="submitTopUp"
      >
        <h3 class="modal-head-order">
          TOP UP Payment</h3>
        <span
          class="close-modal-cancel"
          @click="closeModalOrder"
        >
          <img
            :src="require('@/assets/images/close.png')"
            alt=""
          >
        </span>
        <div class="content-modal-success">
          <div class="left-content-modal-success">
            <b-row class="row-left">
              <b-col md="6">
                <span>TOP UP Amount:</span>
              </b-col>
              <b-col
                md="6"
                class="text-right"
              >
                <span class="value-topup-payment">{{ price }},-</span>
              </b-col>
            </b-row>
            <b-row class="row-left">
              <b-col md="6">
                <span>Tax:</span>
              </b-col>
              <b-col
                md="6"
                class="text-right"
              >
                <span class="value-topup-payment">{{ dataInfo.ppn }}%</span>
              </b-col>
            </b-row>
            <b-row class="row-left">
              <b-col md="12">
                <hr>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <span>Total:</span>
              </b-col>
              <b-col
                md="6"
                class="text-right"
              >
                <span class="value-topup-payment">IDR {{ formatPrice(grandTotal) }},-</span>
              </b-col>
            </b-row>
          </div>
          <div class="right-content-modal-success">
            <b-row style="margin-bottom: 10px">
              <b-col md="12">
                <span class="title-bank-information">Please transfer to following Bank Information below:</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <p class="detail-bank-information">
                  Bank Name: {{ dataInfo.topup_payment_info.bank_name }}</p>
                <p class="detail-bank-information">
                  Account Name: {{ dataInfo.topup_payment_info.account_name }}</p>
                <p class="detail-bank-information">
                  Account Number: {{ dataInfo.topup_payment_info.account_number }}</p>

                <!-- <p>Bank Name: {{ dataInfo.topup_payment_info.bank_name }}</p>
                <p>Account Name: {{ dataInfo.topup_payment_info.account_name }}</p>
                <p>Account Number: {{ dataInfo.topup_payment_info.account_number }}</p> -->
              </b-col>
            </b-row>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- End modal information topup order -->
    <!-- Modal upload payment proof -->
    <div>
      <b-modal
        id="modal-2"
        ref="upload-proof-topup"
        :hide-header-close="true"
        title="Upload Proof Order"
        :ok-only="true"
        ok-title="Submit"
        centered
        @ok="submitUploadProof"
      >
        <b-form-group>
          <b-form-file
            id="proof"
            ref="proof"
            v-model="proof"
            name="proof"
            accept=".pdf"
            placeholder="Upload your proof file"
            class="mt-1"
            :click-to-close="false"
          />
        </b-form-group>
      </b-modal>
    </div>
    <!-- End modal upload payment proof -->
    <!-- Modal upload payment proof -->
    <div>
      <b-modal
        id="modal-3"
        ref="cancel-topup"
        :hide-header="true"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        centered
      >
        <div class="text-center">
          <span
            class="close-modal-cancel"
            @click="closeModalCancel"
          >
            <img
              :src="require('@/assets/images/close.png')"
              alt=""
            >
          </span>
          <img
            :src="require('@/assets/images/warning.png')"
            alt=""
            class="img-warning"
          >
          <h2 class="title-modal-cancel">
            Confirmation cancel payment topup!</h2>
          <p class="desc-modal-cancel">
            Are you sure you want to cancel this payment?</p>
          <div>
            <b-alert
              :show="isErrorCancelTopup"
              variant="danger"
            >
              There is an error in the system
            </b-alert>
          </div>
          <b-button
            class="btn btn-primary btn-yes-cancel"
            @click="submitCancelTopup"
          >
            Yes
          </b-button>
        </div>
      </b-modal>
    </div>
    <!-- End modal upload payment proof -->
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BButton,
  BFormDatepicker,
  BInputGroup,
  BInputGroupAppend,
  BModal,
  BFormGroup,
  BFormFile,
  BAlert,
} from 'bootstrap-vue'
import {
  ValidationProvider,
  ValidationObserver,
  extend,
} from 'vee-validate'
import {
  required,
  // regex,
  // numeric,
} from 'vee-validate/dist/rules'
import Ripple from 'vue-ripple-directive'
import DataTable from '@/views/component/DataTable.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import 'vue-good-table/dist/vue-good-table.css'

// Vue.use(VeeValidate)
extend('required', {
  ...required,
  message: 'This field is required!',
})
// extend('numeric', {
//   ...numeric,
//   message: 'This field is numeric!',
// })
// extend('regex', {
//   ...regex,
//   message: 'Field must be number',
// })
// extend('numberr', value => {
//   const val = value.replace(/\./g, '')
//   // eslint-disable-next-line radix
//   console.log(Number.isInteger(parseInt(val)), 'tes')
//   if (Number.isInteger(val)) return true
//   return 'Field must be number'
// })
extend('min500', value => {
  const val = parseInt(value.replace(/\./g, ''), 10)
  if (Number.isInteger(val) && val >= 500000) return true
  return 'Minimum top up budget IDR 500.000'
})

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormInput,
    BButton,
    BFormDatepicker,
    BInputGroup,
    BInputGroupAppend,
    DataTable,
    BModal,
    BFormGroup,
    BFormFile,
    BAlert,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      status: 0,
      invoiceNo: null,
      price: '',
      priceHidden: '0',
      tax: 0,
      grandTotal: 0,
      titleCloseBtn: 'Okay',
      amountOptions: this.$store.state.topup.amountOptions,
      currentInvoiceNo: this.$store.state.topup.currentInvoiceNo,
      proof: [],
      isErrorCancelTopup: false,
      statusPayment: this.$store.state.topup.statusPayment,
      dataFor: 'dataTopup',
      tableFor: 'topup',
      startdate: '',
      enddate: '',
      disabledBtnFilter: true,
      mutationFor: 'TOPUP',
      action: false,
      filterSearch: false,
    }
  },
  computed: {
    ...mapGetters('topup', {
      dataHistoryTopupField: 'getHistoryTopupField',
      dataHistoryTopupItem: 'getHistoryTopupItem',
      dataHistoryTopupStatus: 'getHistoryTopupStatus',
      isWaitingApproval: 'getIsWaitingApproval',
      getListHistory: 'getItemData',
    }),
    ...mapGetters('datas', {
      dataInfo: 'getDataInfo',
    }),
    search: {
      get() {
        return this.$store.state[this.tableFor][this.dataFor].search
      },
      set(val) {
        this.$store.commit('topup/SET_TOPUP_SEARCH', val)
      },
    },
  },
  watch: {
    search() {
      this.$store.dispatch('topup/getDataList')
    },
  },
  beforeMount() {
    this.getDataList().then(() => {
      // this.getWaitingApprove()
      this.checkStatus()
    })
  },
  mounted() {
    this.getAmountOptions({
      accessToken: this.$store.state.auth.userData.data.accessToken,
    }).then(response => {
      if (response.status) {
        this.amountOptions = response.data
      }
    })
  },
  methods: {
    ...mapMutations('topup', {
      setIsWaitingApproval: 'SET_DATA_WAITING_APPROVAL',
    }),
    ...mapActions('topup', {
      getWaitingApprove: 'waitingPaymentTopup',
    }),
    checkStatus() {
      this.getWaitingApprove().then(result => {
        // console.log(result.data)
        const state = result.data.status
        if (state === false) {
          this.status = 0
        } else {
          this.status = result.data.status
          this.invoiceNo = result.data.invoice_no
        }
      })
      // const status2 = this.getListHistory.find(item => item.status === 1)
      // const status3 = this.getListHistory.find(item => item.status === 2)
      // if (status2) {
      //   this.invoiceNo = status2.invoice_no
      //   this.status = 2
      // } else if (status3) {
      //   this.invoiceNo = status3.invoice_no
      //   this.status = 3
      // } else {
      //   this.status = 1
      // }
    },
    clickedPrice(price) {
      this.price = this.formatRupiah(price)
    },
    // numberWithCommas(x) {
    //   return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.')
    //   // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    // },
    numberWithoutCommas(x) {
      return x.toString().replace(/\./g, '')
    },
    formatRupiah(angka, prefix) {
      let numberString = angka.replace(/[^,\d]/g, '').toString()
      let split = numberString.split(',')
      let sisa = split[0].length % 3
      let rupiah = split[0].substr(0, sisa)
      let ribuan = split[0].substr(sisa).match(/\d{3}/gi)

      if (ribuan) {
        let separator = sisa ? '.' : ''
        rupiah += separator + ribuan.join('.')
      }

      rupiah = split[1] !== undefined ? `${rupiah},${split[1]}` : rupiah
      // eslint-disable-next-line no-nested-ternary
      return prefix === undefined ? rupiah : (rupiah ? `IDR ${rupiah}` : '')
    },
    validation() {
      // return true
      return new Promise((resolve, reject) => {
        this.$refs.valid.validate().then(success => {
          if (success) {
            this.prosesSubmitTopUp()
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    prosesSubmitTopUp() {
      this.price.replace(/\./g, '')
      this.priceHidden = this.numberWithoutCommas(this.price)
      this.tax = ((parseFloat(this.priceHidden) * 11) / 100)
      this.grandTotal = (parseFloat(this.priceHidden) + this.tax)
      this.$refs['success-topup'].show()
    },
    submitTopUp() {
      this.newTopup({
        amount: this.priceHidden,
      }).then(response => {
        this.$refs['success-topup'].hide()
        this.statusPayment = this.$store.state.topup.statusPayment
        this.currentInvoiceNo = response.data.invoice_no
        this.price = 0
        this.priceHidden = 0
        this.tax = 0
        this.getDataList().then(() => {
          this.checkStatus()
        })
      })
    },
    closeModalCancel() {
      this.$refs['cancel-topup'].hide()
    },
    closeModalOrder() {
      this.$refs['success-topup'].hide()
    },
    cancelOrder() {
      this.isErrorCancelTopup = false
      this.$refs['cancel-topup'].show()
    },
    submitCancelTopup() {
      this.cancelPaymentTopup({
        invoice_no: this.invoiceNo,
      }).then(response => {
        if (response.status) {
          this.$refs['cancel-topup'].hide()
          this.getDataList().then(() => {
            this.checkStatus()
          })
        } else {
          this.isErrorCancelTopup = true
        }
      })
    },
    showFormUploadTopup() {
      this.$refs['upload-proof-topup'].show()
    },
    submitUploadProof() {
      this.uploadProofTopup({
        invoice_no: this.invoiceNo,
        upload_payment_proof: this.$refs.proof.files[0],
      }).then(response => {
        if (response.status) {
          // this.statusPayment = 2
          this.$refs['upload-proof-topup'].hide()
          this.$swal({
            icon: 'success',
            title: 'We received your payment',
            text: 'Thank you for your payment. Your credit is now topped up.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          this.getDataList().then(() => {
            this.checkStatus()
          })
        } else {
          this.$refs['upload-proof-topup'].hide()
          this.$swal({
            icon: 'warning',
            title: 'Error Upload Payment Proof',
            text: response.message.upload_payment_proof,
            customClass: {
              confirmButton: 'btn btn-secondary',
            },
          })
        }
      })
    },
    onContext() {
      if (this.startdate !== '' && this.enddate !== '') {
        this.disabledBtnFilter = false
      } else {
        this.disabledBtnFilter = true
        this.$store.commit('topup/SET_STARTDATE', '')
        this.$store.commit('topup/SET_ENDDATE', '')
      }
    },
    filterDate() {
      this.$store.commit('topup/SET_STARTDATE', this.startdate)
      this.$store.commit('topup/SET_ENDDATE', this.enddate)
      this.getDataList().then(() => {
        this.checkStatus()
      })
    },
    formatDateIdr(date) {
      let dd = date.replace(/-/g, '/')
      let d = new Date(dd)
      const dt = (`0${d.getDate()}`).slice(-2)
      const month = (`0${d.getMonth() + 1}`).slice(-2)
      const year = d.getFullYear()
      return `${dt}/${month}/${year}`
    },
    // formatCurrencyIdr(curr) {
    //   let newCurr = curr.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.')
    //   return newCurr.slice(0, -3)
    // },
    formatPrice(value) {
      if (value === null || typeof value === 'undefined') {
        return 0
      }
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    viewDetail(id) {
      this.detailInvoice(id).then(() => {
        this.$router.push({ path: `/topup/view/${id}` })
        // console.log('view-detail')
      })
    },
    ...mapActions('topup', [
      'getAmountOptions',
      'newTopup',
      // 'waitingPaymentTopup',
      'uploadProofTopup',
      'cancelPaymentTopup',
      'getDataList',
    ]),
    ...mapActions('finance', [
      'detailInvoice',
    ]),
    notAvailable() {
      this.$swal({
        title: 'Sorry!',
        text: 'This features is not available for HOUSE Campaign users. For more details, please contact IOH Support.',
        icon: 'warning',
        confirmButtonText: 'OK, I understood',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
  },
}
</script>
<style scoped>
*{
  font-family: 'Rubik';
}

.right-content {
  max-width: 50%;
  float: right;
  width: 100%;
  padding: 20px;
  max-height: 400px !important;
  /* overflow: scroll; */
  margin-bottom: 45px;
}
.left-content-modal-success {
  max-width: 50%;
  width: 100%;
  float: left;
  padding: 20px;
  font-family: 'Rubik';
}
.right-content-modal-success {
  max-width: 50%;
  width: 100%;
  float: right;
  padding: 20px;
  font-family: 'Rubik';
}
.right-content::-webkit-scrollbar {
    display: none;
}
.left-content {
  color: #fff;
  max-width: 50%;
  float: left;
  width: 100%;
  padding: 20px;
}
.title-price, .title-topup-history {
  margin-bottom: 24px;
  color: #5E5873;
  font-weight: bold;
  font-family: 'Rubik';
  font-size: 16px;
  letter-spacing: 1px;
}
.hidebx {
    display: none;
}
.price-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
  margin-bottom: 28px;
}
.lbl-radio {
  text-align: center;
  /* box-shadow: 0px 4px 12px -4px rgba(0, 0, 0, .35); */
  padding: 20px;
  border: 1px solid #4B6AAE;
  cursor: pointer;
  border-radius: 4px;
  width: 100%;
}
.lbl-radio .price {
  color: #4B6AAE;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.5px;
}
input[type=radio]:checked + .lbl-radio {
    border-color: #286ab0;
    background-color: #286ab0;
    color: #fff !important;
}
input[type=radio]:checked + .lbl-radio .price {
    color: #fff !important;
}
.title-input-price, .title-topup-history {
  margin-bottom: 4px;
}
.input-amount {
  margin-bottom: 16px;
}
.btn-success {
  width: 100%;
  background-color: #6EC5B9 !important;
  border: 1px solid #6EC5B9 !important;
}
.btn-primary {
  background-color: #4B6AAE !important;
  border: 1px solid #4B6AAE;
}
.navigation {
  display: grid;
  grid-template-columns: 1fr 1fr 120px 1fr;
  grid-gap: 20px;
}
.input-group-append {
  height: 37px !important;
}

.title-modal {
  font-family: 'Rubik';
  font-weight: bold;
  color: #000;
  font-size: 16px;
  margin: 10px 0;
}
.value-topup-payment {
  font-weight: bold;
}
.row-left {
  margin-bottom: 10px;
}
.detail-bank-information {
  margin: 0px;
}
.title-bank-information {
  font-weight: bold;
}
.content-bank-information {
  color: #6E6B7B;
}
.content-bank-information p {
  margin-bottom: 10px;
  font-size: 16px;
}
.note-information-transfered {
  color: #6E6B7B;
  font-size: 16px;
}
.btn-upload-proof, .btn-cancel-order {
  display: block;
  width: 100%;
  letter-spacing: 1.5px;
  border: none;
  font-weight: bold;
  font-size: 16px;
}
.btn-upload-proof {
  background-color: #6EC5B9 !important;
  margin-bottom: 10px;
}
.btn-cancel-order {
  background-color: #E56084 !important;
}
.close-modal-cancel {
  position: absolute;
  cursor: pointer;
  right: 10px;
  top: 10px;
}
.title-modal-cancel {
  font-weight: bold;
  font-size: 20px !important;
}
.img-warning {
  margin-top: 25px;
  margin-bottom: 10px;
}
.title-modal-cancel {
  margin-bottom: -2px !important;
}
.btn-yes-cancel {
  margin-bottom: 25px;
}
.modal-head-order{
    font-weight: 900;
    font-size: 16px;
    margin-top: 10px;
}
.table-slip{
    border: 1px solid #d9d7df;
    border-radius: 5px;
    margin-left: -0.5rem;
    margin-right: -0.5rem;
}
.grid-floor .grid-floor-col{
  padding: 1.5rem;
}
.filter-btn{
    overflow: hidden;
    white-space: nowrap;
    padding-left: 1rem;
    padding-right: 1rem;
}
.filter-tools > label{
  overflow: hidden !important;
}
</style>
